import React from 'react'

const SignatureIcon = (
  <>
    <path
      d="M4 19.361C7.77027 22.0721 13.7737 21.2104 11.5243 18.3097C9.27487 15.409 24.6094 17.9767 20.1983 19.8163C15.7873 21.6559 10.2414 14.3921 19.082 13"
      stroke="currentColor"
      strokeLinecap="round"
      fill="none"
    />
    <path
      d="M4.84339 18C4.89339 18 4.94338 17.995 4.99338 17.9875L9.19796 17.25C9.24796 17.24 9.29545 17.2175 9.33045 17.18L19.9269 6.5825C19.9501 6.55937 19.9685 6.5319 19.981 6.50166C19.9935 6.47141 20 6.43899 20 6.40625C20 6.37351 19.9935 6.34109 19.981 6.31084C19.9685 6.2806 19.9501 6.25313 19.9269 6.23L15.7723 2.0725C15.7248 2.025 15.6623 2 15.5948 2C15.5273 2 15.4648 2.025 15.4173 2.0725L4.82089 12.67C4.7834 12.7075 4.7609 12.7525 4.7509 12.8025L4.01348 17.0075C3.98916 17.1414 3.99785 17.2793 4.03879 17.4091C4.07973 17.5389 4.1517 17.6568 4.24845 17.7525C4.41344 17.9125 4.62092 18 4.84339 18ZM6.52823 13.64L15.5948 4.575L17.4271 6.4075L8.36054 15.4725L6.13826 15.865L6.52823 13.64Z"
      fill="currentColor"
    />
  </>
)

export default SignatureIcon
